import Styled from 'styled-components'

export default Styled.form``



// WEBPACK FOOTER //
// ./src/components/Form/index.js